module.exports = __webpack_public_path__ + "static/media/office.4daba8e3.jpg";